import { render, staticRenderFns } from "./ProductGroup.vue?vue&type=template&id=2880e960"
import script from "./ProductGroup.vue?vue&type=script&lang=js"
export * from "./ProductGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports